import { render, staticRenderFns } from "./NotifyMe.vue?vue&type=template&id=e25f898a"
import script from "./NotifyMe.vue?vue&type=script&lang=js"
export * from "./NotifyMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports